import { useState } from 'react';

import { useGetShopCommissionsQuery } from '../store/shop-commissions-api';
import { useShowResponseStatus } from '@/shared';

import type { TGetShopCommissionsParams } from '../store/types';

const initialParams: TGetShopCommissionsParams = {
  pageSize: 20,
  page: 1,
  ascending: false,
};

type Options = {
  pageSize?: number;
};

export const useGetShopCommissions = ({ pageSize }: Options) => {
  const [params, setParams] = useState<TGetShopCommissionsParams>(pageSize ? { ...initialParams, pageSize } : initialParams);
  const { data, isLoading, isError } = useGetShopCommissionsQuery(params);
  const itemsCount = data?.count;
  const items = data?.items ?? [];

  useShowResponseStatus({
    isError,
    errorMassage: 'Произошла ошибка!',
  });

  const handlePaginationChange = (page: number) => {
    setParams((prev) => ({
      ...prev,
      page,
    }));
  };

  return {
    params,
    items,
    itemsCount,
    isLoading,
    handlePaginationChange,
  };
};
